// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OZMv","label":"styles_label__2SmFK"};